/**
 * 网络请求类
 * 数据的请求
 */

import axios, { AxiosResponse } from "axios";
import { ElMessage } from "element-plus";
import { getLocalStorage } from "@/utils/localStorage";

export interface ILoginParams {
  // mid: number;
  account: string;
  password: string;
}

export interface IBaseResponse<T = any> {
  success: boolean;
  message?: string;
  data?: T;
}

export interface IPageData {
  total: number;
  pageNum: number;
  pageSize: number;
}

export interface IBaseResponsePage<T = any> extends IBaseResponse<T> {
  // message?: string;
  // data?: T;
  pageData?: IPageData;
  extra?: any;
}

export interface ILoginData {
  adminId: number;
  adminName: string;
  token: string;
  loginId: number;
}

export interface IRestGetParams {
  // 查询方法
  method: string;
  data?: Record<string, any> | string;
}

class RestInstance {
  data<T> (url:string, config: Record<string, any>, callback?: (t?: T) => void, errorCallback?: (error:any) => void) {
    const token = getLocalStorage("token");
    axios
      .post<IBaseResponse<any>>(url, config, {
        headers: { token }
      })
      .then(function (res) {
        if (res && res.data && res.data.success) {
          if (callback) callback(res.data.data);
        } else {
          const backData = { success: false, message: res.data.message ?? "网络请求失败" };
          if (errorCallback) errorCallback(backData);
          else ElMessage.error(backData.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        const backData = { success: false, message: "网络请求失败", data: config.data };
        if (errorCallback) errorCallback(backData);
        else ElMessage.error(backData.message);
      });
  }

  baFutureData<T> (config: Record<string, any>, callback?: (t?: T) => void, errorCallback?: (error:any) => void) {
    this.data("https://ba.w168.xyz/api/custom", config, callback, errorCallback);
  }

  baStableData<T> (config: Record<string, any>, callback?: (t?: T) => void, errorCallback?: (error:any) => void) {
    this.data("https://sh.w168.xyz/api/custom", config, callback, errorCallback);
  }
}

const rest = new RestInstance();

export default rest;
